import axios from "../axios";

export const pickingListsApi = {
  // Send booleans as "true"/"false" strings so Rails always parses unpicked_only / warehouse_only reliably (query params).
  getOverview: (params = {}) => {
    const q = { ...params };
    if (typeof q.unpicked_only === "boolean") q.unpicked_only = q.unpicked_only ? "true" : "false";
    if (typeof q.warehouse_only === "boolean") q.warehouse_only = q.warehouse_only ? "true" : "false";
    if (typeof q.include_skipped === "boolean") q.include_skipped = q.include_skipped ? "true" : "false";
    // Duplicate camelCase keys for proxies / older clients; Rails reads both.
    q.unpickedOnly = q.unpicked_only;
    q.warehouseOnly = q.warehouse_only;
    q.includeSkipped = q.include_skipped;
    if (q.query === "" || q.query == null) delete q.query;
    return axios.get("/inventory/picking_lists", { params: q });
  },

  togglePicked: (payload) => axios.post("/inventory/picking_lists/toggle_picked", payload),

  toggleSkipPicking: (payload) => axios.post("/inventory/picking_lists/toggle_skip_picking", payload),

  sendReminder: () => axios.post("/inventory/picking_lists/send_reminder", {}),

  getPickingSettings: () => axios.get("/inventory/picking_settings"),

  updatePickingSettings: (picking_list_reminder_user_ids) =>
    axios.patch("/inventory/picking_settings", { picking_list_reminder_user_ids }),
};
